<template>
  <div class="box">
    <div class="login">
      <img src="../../assets/logo.png" alt="" />
      <p>孺教网综合教学平台</p>
      <div>
        <el-input
          clearable
          placeholder="请输入手机号"
          prefix-icon="el-icon-user"
          v-model="input1"
          @input="hh"
          @blur="hh"
        >
        </el-input>
        <div class="tip" v-show="isNumber">{{ tips1 }}</div>
      </div>

      <div>
        <el-input
          clearable
          placeholder="请输入密码"
          v-model="input2"
          @blur="uu"
          @input="uu"
          type="password"
          prefix-icon="el-icon-lock"
        >
        </el-input>
        <div class="tip" v-show="isPassword">{{ tips2 }}</div>
      </div>

      <div class="clearfix" style="margin: 10px 0">
        <el-checkbox
          v-model="checked"
          style="margin-top: 10px; margin-right: 60px"
          >自动登录</el-checkbox
        >
        <el-button @click="$router.push('/register')" type="text" class="btn"
          >立即注册</el-button
        >
        <el-button
          type="text"
          class="fr btn"
          @click="$router.push('/forgetPassword')"
          >忘记密码？</el-button
        >
      </div>
      <el-button type="primary" style="width: 100%" @click="handleLogin"
        >登录</el-button
      >
      <div class="help">
        <span>帮助</span>
        <span>隐私</span>
        <span>条款</span>
      </div>
    </div>
    <div class="bottom">
      <p>版权及最终解释权归山东大课堂信息技术有限公司所有</p>
      <p>
        Copy right@2018 山东大课堂信息技术有限公司 all Rights Reserved 版权所有
      </p>
    </div>
  </div>
</template>

<script>
import URL from "../../api/index";
import { rand } from "../../api/http";
import axios from "axios";
export default {
  data() {
    return {
      input1: "",
      input2: "",
      checked: true,
      isNumber: false,
      isPassword: false,
      tips1: "请输入手机号",
      tips2: "请输入密码",
    };
  },
  components: {},
  mounted() {},
  methods: {
    hh() {
      if (!this.input1) {
        this.isNumber = true;
      } else {
        this.isNumber = false;
        var tests =
          /^(((13[0-9])|(14[0-9])|(15[0-9])|(16[0-9])|(17[0-9])|(18[0-9])|(19[0-9]))+\d{8})$/;
        if (tests.test(this.input1)) {
          this.isNumber = false;
        } else {
          this.isNumber = true;
          this.tips1 = "请输入正确格式的手机号";
        }
      }
    },

    uu() {
      if (!this.input2) {
        this.isPassword = true;
      } else {
        this.isPassword = false;
        var re = /^[\w!-@#$%^&*]{6,20}$/;
        if (re.test(this.input2)) {
          this.isPassword = false;
        } else {
          this.isPassword = true;
          this.tips2 = "请输入6到20位字母或数字的密码";
        }
      }
    },
    // 数据上报
    getRecordRjw(hh) {
      axios.get("https://access.rujiaowang.net/GetLogServer").then((res) => {
        this.client_ip = res.data.result.client_ip;
        var differenctime =
          res.data.result.net_ts - Date.parse(new Date()) / 1000;
        var data_traceid =
          `${hh.result.user_id}` +
          `${Number(Date.parse(new Date())) / 1000 + differenctime}` +
          `${rand(1000, 9999)}`;
        localStorage.setItem("data_traceid", JSON.stringify(data_traceid));
        var saydata = {
          product_name: "教师工作台",
          log_version: "v2.0.1",
          action: "user_login",
          user_id: String(hh.result.user_id),
          user_role: String(hh.result.user_type),
          user_name: String(hh.result.user_nicename),
          ts: String(Number(Date.parse(new Date())) / 1000 + differenctime),
          trace_id: data_traceid,
          dev_id: "",
          dev_name: "",
          client_ip: this.client_ip,
          os: "",
          cpu_name: "",
          cpu_use: "",
          app_version: "v2.0.0",
          mem_size: "",
          mem_use: "",
          net: "",
          electric: "",
          extend: "",
          remark: `${hh.result.user_nicename}` + "登录了教师工作台",
          data: {
            school_name: hh.result.teacher_info.school_name
              ? `${hh.result.teacher_info.school_name}`
              : "",
            school_id: hh.result.teacher_info.school_id
              ? `${hh.result.teacher_info.school_id}`
              : "",
          },
        };
        axios.post("http://47.114.114.56:9002/RecordRjw", saydata);
      });
    },
    handleLogin() {
      var data = {
        login_name: this.input1,
        password: this.input2,
      };
      if (!this.input2) {
        this.isPassword = true;
      }
      if (!this.input1) {
        this.isNumber = true;
      }
      if (!this.isNumber && !this.isPassword) {
        this.$post(URL.getlogin, data).then((res) => {
          localStorage.setItem("loginInfo", JSON.stringify(res.result));
          if (res.state == 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.getRecordRjw(res);
            // 是否有学校
            if (res.result.school_id) {
              var datainfo = {
                school_id: res.result.school_id,
                token: res.result.token,
              };
              this.$post(URL.getSchool, datainfo).then((res1) => {
                // console.log(res1.result.school_name);
                localStorage.setItem("school", res1.result.school_name);
                this.$router.push("/home");
              });
            } else {
              this.$message("没有绑定学校");
              this.$router.push("/schoolserve");
            }
          } else {
            this.$message(res.msg);
          }
        });
      }
    },
  },
};
</script>

<style lang='less' scoped>
.box {
  width: 100%;
  height: 100%;
  position: relative;
  background-image: url("../../assets/login_img.png");
  background-position: 0 -100px;
  .tip {
    font-size: 12px;
    color: red;
    // padding-left: 15px;
  }
  img {
    width: 100px;
  }
  .login {
    border-radius: 8px;
    background-color: #fff;
    position: absolute;
    top: 22%;
    right: 15%;
    padding: 50px 40px;
    p {
      font-size: 26px;
      color: #3b8afd;
      font-weight: 700;
      margin-top: 10px;
      margin-bottom: 16px;
    }
  }
  .el-checkbox /deep/ .el-checkbox__label {
    font-size: 12px !important;
  }
  .btn {
    font-size: 12px !important;
  }
  .el-input {
    width: 320px;
    margin-top: 20px;
    margin-bottom: 6px;
  }
  .help {
    font-size: 12px;
    text-align: center;
    margin-top: 30px;
    span {
      padding: 0 16px;
    }
  }
  .bottom {
    position: absolute;
    text-align: center;
    bottom: 40px;
    left: 40%;
    color: #fff;
    font-size: 12px;
    p {
      margin-bottom: 20px;
    }
  }
}
</style>
